import { useEffect, useReducer, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import ModalKmkopReportComponent from "./modalKmkopReportComponent";

let initialValue = {
  date: "",
  assessmentDate: "",
  location: "",
  instructorName: "",
  sectionHeadPlantName: "",
  sectionHeadKpName: "",
  sectionHeadHRSName: "",
  userName: "",
  ukList: [],
  participantList: [],
  selectedParticipant: [],
};
const reducer = (state, action) => {
  switch (action.type) {
    case "date":
      return { ...state, date: action.value };
    case "assessmentDate":
      return { ...state, assessmentDate: action.value };
    case "location":
      return { ...state, location: action.value };
    case "instructorName":
      return { ...state, instructorName: action.value };
    case "sectionHeadPlantName":
      return { ...state, sectionHeadPlantName: action.value };
    case "sectionHeadKpName":
      return { ...state, sectionHeadKpName: action.value };
    case "sectionHeadHRSName":
      return { ...state, sectionHeadHRSName: action.value };
    case "userName":
      return { ...state, userName: action.value };
    case "ukList":
      return { ...state, ukList: action.value };
    case "participantList":
      return { ...state, participantList: action.value };
    case "selectedParticipant":
      return { ...state, selectedParticipant: action.value };
    case "RESET_STATE":
      return initialValue;
    default:
      break;
  }
};

/**
 * @param {{
 *   show: boolean,
 *   onHide: () => void,
 *   data: {
 *     date: string,
 *     assessmentDate: string,
 *     location: string,
 *     instructorName: string,
 *     userName: string,
 *     ukList: Array<object>,
 *     participantList: Array<object>
 *   },
 *   submitClick: (payload: {
 *     date: string,
 *     assessmentDate: string,
 *     location: string,
 *     instructorName: string,
 *     sectionHeadPlantName: string,
 *     sectionHeadKpName: string,
 *     sectionHeadHRSName: string,
 *     userName: string,
 *     ukList: Array<object>,
 *     participantList: Array<object>,
 *     selectedParticipant: Array<object>
 *   }) => void
 * }} props
 *
 * @returns {JSX.Element}
 */

function ModalKmkopReport({
  show,
  onHide,
  submitClick,
  data = {
    date: "",
    location: "",
    instructorName: "",
    userName: "",
    ukList: [],
    participantList: [],
  },
}) {
  const [values, dispatch] = useReducer(reducer, initialValue);
  const bindParticipantList = (participantList = []) => {
    if (participantList.length < 1 || !participantList) return [];
    return participantList.map((item) => ({
      participantId: item.id,
      name: item.manpowerData.nama,
      company: item.manpowerData.company.name,
      position: item.manpowerData.jabatanFn,
    }));
  };
  useEffect(() => {
    if (!show) {
      return;
    }
    dispatch({ type: "RESET_STATE" });
    const { date, location, instructorName, userName, ukList, participantList } = data;
    dispatch({ type: "date", value: date });
    dispatch({ type: "assessmentDate", value: date });
    dispatch({ type: "location", value: location });
    dispatch({ type: "instructorName", value: instructorName });
    dispatch({ type: "userName", value: userName });
    dispatch({ type: "ukList", value: ukList });
    dispatch({ type: "participantList", value: participantList });
  }, [show]);

  const submitDisabled = !values.date || !values.assessmentDate || !values.selectedParticipant?.length;
  return (
    <>
      <Modal show={show} onHide={() => onHide()} size="lg" backdrop={"static"}>
        <ModalHeader closeButton>
          <h5 className="modal-title">Will anything be changed?</h5>
        </ModalHeader>
        <ModalBody>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label" htmlFor="tanggal">
              Tanggal
            </label>
            <div className="col-sm-10">
              <input value={values.date} onChange={(e) => dispatch({ type: "date", value: e.target.value })} type="date" className="form-control" id="tanggal" />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label" htmlFor="tanggalAss">
              Tanggal Ass.
            </label>
            <div className="col-sm-10">
              <input value={values.assessmentDate} onChange={(e) => dispatch({ type: "assessmentDate", value: e.target.value })} type="date" className="form-control" id="tanggalAss" />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label" htmlFor="lokasi">
              Lokasi
            </label>
            <div className="col-sm-10">
              <input value={values.location} onChange={(e) => dispatch({ type: "location", value: e.target.value })} type="text" className="form-control" id="lokasi" />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label" htmlFor="Instructor">
              Instructor
            </label>
            <div className="col-sm-10">
              <input value={values.instructorName} onChange={(e) => dispatch({ type: "instructorName", value: e.target.value })} type="text" className="form-control" id="Instructor" />
            </div>
          </div>
          {/* ///////// */}
          <ModalKmkopReportComponent participantList={bindParticipantList(values.participantList)} onChange={(e) => dispatch({ type: "selectedParticipant", value: e })} />
        </ModalBody>
        <ModalFooter>
          <button disabled={submitDisabled} onClick={() => submitClick(values)} type="button" className="btn btn-outline-theme">
            Generate
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalKmkopReport;
